import { Base } from "../../../../../base/components/base"
import services from "../../../../../services"
import { RateHeader } from "../../rate-table/rate-header"
import { RateTr } from "../../rate-table/rate-tr"
import { Loading } from "../../shared/loading"
import { submitButton } from "../../shared/submit-button"
import { Tab } from "../tab"

export const CashTab = () => {
    const base = Tab('cash')

    const table = Base('table')
    table.cssClass({ direction: 'rtl', borderSpacing: '0' })
    base.append(table)

    const header = RateHeader()
    table.append(header)

    const allowed_cash = [
        'usd_cash_sell',//فروش دلار نقدی آمریکا
        'usd_cash_buy',//خرید دلار نقدی آمریکا
        'eur_cash_sell', //فروش یورو نقدی
        'eur_cash_buy', //خرید یورو نقدی
        'gbp_cash_sell', //فروش پوند نقدی
        'gbp_cash_buy', //خرید پوند نقدی
        'usdt_sell', //فروش تتر
        'usdt_buy', //خرید تتر
    ]

    const loading = Loading()
    base.append(loading)

    let rows: any[] = []
    services.rates.getRates().then(rates => {
        loading.remove()
        rates.forEach(rate => {
            if (!allowed_cash.includes(rate.key)) return
            const row = RateTr(rate)
            rows.push(row)
            table.append(row)
        })

        const bigButton = submitButton()
        bigButton.enable()
        const row2 = RateTr()
        row2.style({ height: '80px', borderTop: '1px solid #ccc', padding: '10px' })
        row2.append(bigButton)
        table.append(row2)

        bigButton.el.onclick =  async () => {
            const values = rows.map(row => row.getValue())
            const toUpdate = values.filter(row => {
                if (row.changed === false) return false
                if (row.meta.db === false) return false
                return true
            })

            bigButton.disable()
            bigButton.el.innerText = 'در حال به روز رسانی...'

            for (const item of toUpdate) {
                try {
                    await services.rates.updateRate({ item: item.value, change: item.value.change, telegramShouldUpdate: false, details: item.value.details, title: item.value.title })
                } catch (error) {
                    console.log('error:', error)
                }
            }

            bigButton.el.innerText = 'اطلاعات به روز شد'
            setTimeout(() => {
                bigButton.el.innerText = 'به روز رسانی اطلاعات'
                bigButton.enable()
            }, 1000);
        }

    })

    return base
}